import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { notificationsRioEvent } from "../lib/rio";
import { EventTypes, recordEvents } from "./newRelicEvents";
import { texts } from "../config/texts";
export function handleError(error, eventName) {
  var errorMessages = texts.errorMessages;
  switch (error.code) {
    case 'invalid_grant':
      {
        recordEvents(_defineProperty({}, eventName, {
          error: error.message
        }));
        // temporary if block until apw fix is deployed
        if (eventName === EventTypes.sendEmailFail) {
          notificationsRioEvent({
            notifications: {
              type: 'error',
              message_name: 'expired token',
              message_detail: "".concat(errorMessages.expired_token, " ").concat(errorMessages.start_over_link_text)
            }
          });
          return errorMessages.expired_token;
        } else {
          notificationsRioEvent({
            notifications: {
              type: 'error',
              message_name: 'invalid code',
              message_detail: 'Invalid code. Please try again.'
            }
          });
          return errorMessages.invalid_grant;
        }
      }
    case 'expired_token':
      {
        notificationsRioEvent({
          notifications: {
            type: 'error',
            message_name: 'expired token',
            message_detail: "".concat(errorMessages.expired_token, " ").concat(errorMessages.start_over_link_text)
          }
        });
        recordEvents(_defineProperty({}, eventName, {
          error: error.message
        }));
        return errorMessages.expired_token;
      }
    case 'invalid_request':
      {
        notificationsRioEvent({
          notifications: {
            type: 'error',
            message_name: 'too many requests',
            message_detail: "".concat(errorMessages.too_many_requests, " ").concat(errorMessages.try_again_text, " ").concat(errorMessages.later_text)
          }
        });
        recordEvents(_defineProperty({}, eventName, {
          error: error.message
        }));
        return errorMessages.too_many_requests;
      }
    default:
      {
        notificationsRioEvent({
          notifications: {
            type: 'error',
            message_name: 'Unknown error',
            message_detail: 'Something went wrong.'
          }
        });
        recordEvents(_defineProperty({}, eventName, {
          error: error.message
        }));
        return errorMessages.downstream_server_issue;
      }
  }
}